import { AnalyticsBrowser } from "@segment/analytics-next";
import { DEFAULT_CONFIG } from "../config/Config";

export default AnalyticsBrowser.load({
  writeKey: DEFAULT_CONFIG.segment_write_key,
});
